import { render, staticRenderFns } from "./GlobalCampaignList.vue?vue&type=template&id=2da91bd6&scoped=true"
import script from "./GlobalCampaignList.vue?vue&type=script&lang=js"
export * from "./GlobalCampaignList.vue?vue&type=script&lang=js"
import style0 from "./GlobalCampaignList.vue?vue&type=style&index=0&id=2da91bd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da91bd6",
  null
  
)

export default component.exports